import * as React from "react";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateField } from "@mui/x-date-pickers/DateField";
import MuiTheme from "./MuiTheme";

function MuiDateField({ value, onChange, disabled = false, label }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
      <MuiTheme>
        <DateField
          label={label}
          onChange={onChange}
          className="w-full"
          slotProps={{ textField: { size: "small" } }}
          defaultValue={value}
          value={value}
        />
      </MuiTheme>
    </LocalizationProvider>
  );
}

export default MuiDateField;
